export default __webpack_public_path__ + "locales/sr-Latn-RS/PrivacyPage.json?hash=37ecaa3aca467c849caadda08853592b";